/* eslint-disable no-magic-numbers */
/* eslint-disable init-declarations */

import inArray from '@/helpers/inArray';

const callbacks = function() {
  // В jQuery options передаются как аргумент, здесь нам сразу нужно memory
  const options = { memory: true };

  // Flag to know if list is currently firing
  let firing;

  // Last fire value for non-forgettable lists
  let memory;

  // Flag to know if list was already fired
  let fired;

  // Flag to prevent firing
  let locked;

  // Actual callback list
  let list = [];

  // Queue of execution data for repeatable lists
  let queue = [];

  // Index of currently firing callback (modified by add/remove as needed)
  let firingIndex = -1;

  // Fire callbacks
  let fire = function() {
    // Enforce single-firing
    locked = locked || options.once;

    // Execute callbacks for all pending executions,
    // respecting firingIndex overrides and runtime changes
    fired = firing = true;
    for (; queue.length; firingIndex = -1) {
      memory = queue.shift();
      while (++firingIndex < list.length) {
        let shouldStopList = false;
        try {
          const returnValue = list[ firingIndex ].apply(memory[ 0 ], memory[ 1 ]);
          if (returnValue === false && options.stopOnFalse) {
            shouldStopList = true;
          }
        } catch (err) {
          console.warn(err);
        }
        if (shouldStopList) {
          // Jump to end and forget the data so .add doesn't re-fire
          firingIndex = list.length;
          memory = false;
        }
      }
    }

    // Forget the data if we're done with it
    if (!options.memory) {
      memory = false;
    }

    firing = false;

    // Clean up if we're done firing for good
    if (locked) {
      // Keep an empty list if we have data for future add calls
      if (memory) {
        list = [];

      // Otherwise, this object is spent
      } else {
        list = '';
      }
    }
  };

  // Actual Callbacks object
  let obj = {

    // Add a callback or a collection of callbacks to the list
    add: function() {
      if (list) {
        // If we have memory from a past run, we should fire after adding
        if (memory && !firing) {
          firingIndex = list.length - 1;
          queue.push(memory);
        }

        (function add(args) {
          [ ...args ].forEach(arg => {
            if (typeof arg === 'function') {
              if (!options.unique || !obj.has(arg)) {
                list.push(arg);
              }
            } else if (arg && arg.length && typeof arg !== 'string') {
              // Inspect recursively
              add(arg);
            }
          });
        })(arguments);

        if (memory && !firing) {
          fire();
        }
      }

      return this;
    },

    // Remove a callback from the list
    remove: function() {
      for (const arg of arguments) {
        let index;

        while ((index = inArray(arg, list, index)) > -1) {
          list.splice(index, 1);

          // Handle firing indexes
          if (index <= firingIndex) {
            firingIndex--;
          }
        }
      }

      return this;
    },

    // Check if a given callback is in the list.
    // If no argument is given, return whether or not list has callbacks attached.
    has: function(func) {
      return func ?
        list.includes(func) :
        list.length > 0;
    },

    // Remove all callbacks from the list
    empty: function() {
      if (list) {
        list = [];
      }

      return this;
    },

    // Disable .fire and .add
    // Abort any current/pending executions
    // Clear all callbacks and values
    disable: function() {
      locked = queue = [];
      list = memory = '';

      return this;
    },
    disabled: function() {
      return !list;
    },

    // Disable .fire
    // Also disable .add unless we have memory (since it would have no effect)
    // Abort any pending executions
    lock: function() {
      locked = queue = [];

      if (!memory && !firing) {
        list = memory = '';
      }

      return this;
    },
    locked: function() {
      return !!locked;
    },

    // Call all callbacks with the given context and arguments
    fireWith: function(context, args) {
      if (!locked) {
        let argsArr = args || [];

        argsArr = [ context, argsArr.slice ? argsArr.slice() : argsArr ];
        queue.push(argsArr);

        if (!firing) {
          fire();
        }
      }

      return this;
    },

    // Call all the callbacks with the given arguments
    fire: function() {
      obj.fireWith(this, arguments);

      return this;
    },

    // To know if the callbacks have already been called at least once
    fired: function() {
      return !!fired;
    }
  };

  return obj;
};

export default callbacks;
